'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _textfield = require('../textfield');

var _reactAutocomplete = require('react-autocomplete');

var _reactAutocomplete2 = _interopRequireDefault(_reactAutocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Autocomplete = function Autocomplete(props) {
  var error = props.error,
      value = props.value,
      _props$valueKey = props.valueKey,
      valueKey = _props$valueKey === undefined ? 'value' : _props$valueKey,
      _props$labelKey = props.labelKey,
      labelKey = _props$labelKey === undefined ? 'label' : _props$labelKey,
      _onChange = props.onChange,
      _onBlur = props.onBlur,
      rest = _objectWithoutProperties(props, ['error', 'value', 'valueKey', 'labelKey', 'onChange', 'onBlur']);

  var inputProps = {
    className: (0, _textfield.inputClassName)(props),
    onBlur: function onBlur(e) {
      return _onBlur(value);
    }
  };

  return _react2.default.createElement(_reactAutocomplete2.default, _extends({}, rest, {
    className: 'textfield textfield--boxed',
    onChange: function onChange(event, value) {
      return _onChange(value);
    },
    onSelect: function onSelect(value) {
      return _onChange(value);
    },
    value: value,
    wrapperStyle: { position: 'relative' },
    inputProps: inputProps,
    getItemValue: function getItemValue(item) {
      return item.label;
    },
    shouldItemRender: function shouldItemRender(item, value) {
      return item.label.toLowerCase().indexOf(value.toLowerCase()) !== -1 || item.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    renderItem: function renderItem(item, isHighlighted) {
      return _react2.default.createElement(
        'div',
        {
          className: isHighlighted ? 'autocomplete__item--highlight' : '',
          key: item.name
        },
        item.label
      );
    },
    renderMenu: function renderMenu(items, value, style) {
      return _react2.default.createElement('div', {
        className: 'autocomplete',
        children: items,
        style: items.length == 0 ? { display: 'none' } : null
      });
    }
  }));
};

exports.default = Autocomplete;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/lib/components/autocomplete/autocomplete.js
// module id = 1348
// module chunks = 249